import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isConRegisterButtonLoader: false,
  isConReminderButtonLoader: false,
  isCreatePasswordButtonLoader: false,
  isEnableTwoFactorLoader: false,
  isLoader: true,
  isLoginButtonLoader: false,
  isTwoFactorLoginButtonLoader: false,
  isLoginOrRegisterButtonLoader: false,
  isResendButtonLoader: false,
  isTwoFactorRegisterButtonLoader: false,
};

const loadersSlice = createSlice({
  name: "LOADERS",
  initialState,
  reducers: {
    setCONRegisterButtonLoader: (state, action) => {
      state.isConRegisterButtonLoader = action.payload;
    },
    setCONReminderButtonLoader: (state, action) => {
      state.isConReminderButtonLoader = action.payload;
    },
    setCreatePasswordButtonLoader: (state, action) => {
      state.isCreatePasswordButtonLoader = action.payload;
    },
    setEnableTwoFactorLoader: (state, action) => {
      state.isEnableTwoFactorLoader = action.payload;
    },
    setLoader: (state, action) => {
      state.isLoader = action.payload;
    },
    setLoginButtonLoader: (state, action) => {
      state.isLoginButtonLoader = action.payload;
    },
    setTwoFactorLoginButtonLoader: (state, action) => {
      state.isTwoFactorLoginButtonLoader = action.payload;
    },
    setLoginOrRegisterButtonLoader: (state, action) => {
      state.isLoginOrRegisterButtonLoader = action.payload;
    },
    setResendButtonLoader: (state, action) => {
      state.isResendButtonLoader = action.payload;
    },
    setTwoFactorRegisterButtonLoader: (state, action) => {
      state.isTwoFactorRegisterButtonLoader = action.payload;
    },
  },
});

export const {
  setCONRegisterButtonLoader,
  setCONReminderButtonLoader,
  setCreatePasswordButtonLoader,
  setEnableTwoFactorLoader,
  setLoader,
  setLoginButtonLoader,
  setLoginOrRegisterButtonLoader,
  setResendButtonLoader,
  setTwoFactorLoginButtonLoader,
  setTwoFactorRegisterButtonLoader,
} = loadersSlice.actions;

export default loadersSlice.reducer;
